import { render, staticRenderFns } from "./avg-answer-time.vue?vue&type=template&id=0314cc2d&"
import script from "./avg-answer-time.vue?vue&type=script&lang=js&"
export * from "./avg-answer-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports